module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Landing-page-w720.7e1f65d5.jpg";